import { Tag } from "@design-system/Tag/Tag";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    APPLIED_TEMPLATE_SOURCE_LABELS,
    type AppliedTemplateSource,
} from "./applyReportTemplateRows";

const APPLIED_TEMPLATE_SOURCE_TOOLTIPS: Record<AppliedTemplateSource, string> =
    {
        firm: "Uses your firm default.",
        client: "Assigned to this client and its entities.",
        entity: "Assigned to this entity only.",
    };

export const AppliedTemplateSourceTag = ({
    source,
}: {
    source: AppliedTemplateSource;
}) => (
    <Tooltip content={APPLIED_TEMPLATE_SOURCE_TOOLTIPS[source]}>
        <span>
            <Tag color="neutral" size="sm" outline>
                {APPLIED_TEMPLATE_SOURCE_LABELS[source]}
            </Tag>
        </span>
    </Tooltip>
);
